// Vendors
import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

// Styles
import "./step-navigation-buttons.scss";

// Utils
import history from "../../common/history";

const StepNavigationButtons = () => {
    const { t } = useTranslation();

    return (
      <Row className="btn-group-align" sm={1} xs={1} md={2} lg={2}>
        <Col pull-right>
          <Button
            variant="outline-primary"
            className="back-button"
            onClick={() => {
              window.scrollTo(0, 0);
              history.push(t("URLS.SELECT_VITAL_RECORD"));
            }}
          >
            {t("COMMONS.BACK")}
          </Button>
        </Col>
        <Col>
          <Button
            variant="primary"
            className="next-button"
            type="submit"
          >
            {t("COMMONS.NEXT")}
          </Button>
        </Col>
      </Row>
    )
}

export default StepNavigationButtons;